import { Grid, Typography, Button, Link } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import Lemmertz from '../images/Lemmertz.png'

export default function CardsEnd() {

    const linkcicb = () => {
        window.open('https://www.google.com.br/maps/place/Centro+Internacional+de+Conven%C3%A7%C3%B5es+do+Brasil/@-15.8156794,-47.8496181,17z/data=!3m1!4b1!4m6!3m5!1s0x935a235b9cbb04f5:0x891cb2fcc1ef260!8m2!3d-15.8156846!4d-47.8447472!16s%2Fg%2F1q5gppnwh?entry=ttu', '_blank')
    }


    return (
        <div >
            <div className='cardsend'>
            <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: { xl: '450px', lg: '380px', xs: '80vw' },
                        height: { xl: '300px', lg: '230px', xs: '28vh' },
                        borderRadius: '35px',
                        backgroundColor: '#0147A9',
                        textAlign: 'center',
                        padding: '15px',
                        marginBottom: '3%',
                        marginRight: '5%',
                    }}
                >
                    <Grid item>
                        <Link href="https://imi-br.com.br/" target="_blank">
                            <Typography sx={{ color: '#fff', fontSize: { xl: '19px', lg: '14px', xs: '10px' }, marginBottom: '10%' }}>
                                Patrocínios
                            </Typography>
                            <img src="https://imi-br.com.br/wp-content/uploads/2022/04/IMIBrLogoBranca.png" alt="Logo Lemmertz" />
                            <Typography sx={{ color: '#fff', fontSize: { xl: '19px', lg: '14px', xs: '10px' }, marginTop: '15%' }}>
                                (61) 9 98275 3620
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: { xl: '450px', lg: '380px', xs: '80vw' },
                        height: { xl: '300px', lg: '230px', xs: '35vh' },
                        borderRadius: '35px',
                        backgroundColor: '#005BAB',
                        textAlign: 'center',
                        padding: '15px',
                        marginRight: '5%',
                        marginBottom: '3%'
                    }}
                >
                    <Grid item>
                        <Link href="https://www.lemmertzturismo.com.br/pagina.php?tag=xxivmarchaMMERTZ" target="_blank">
                            <Typography sx={{ color: '#fff', fontSize: { xl: '17px', lg: '14px', xs: '10px' } }}>
                                Agência de Turismo Credenciada
                            </Typography>
                            <img src={Lemmertz} alt="Logo Lemmertz" />
                            <Typography sx={{ color: '#fff', fontSize: { xl: '17px', lg: '14px', xs: '10px' } }}>
                                Contrate antecipadamente seu pacote de viagens
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: { xl: '450px', lg: '380px', xs: '80vw' },
                        height: { xl: '300px', lg: '230px', xs: '35vh' },
                        borderRadius: '35px',
                        backgroundColor: '#FF8A00',
                        textAlign: 'center',
                        padding: '5px',
                        marginBottom: '3%'
                    }}
                >
                    <Grid item>
                        <Typography sx={{ fontSize: { xl: '25px', lg: '20px' }, color: '#fff', fontWeight: 'bold' }}>
                            <LocationOnOutlinedIcon
                                sx={{ fontSize: 30 }}
                            /> LOCAL DO EVENTO
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold', fontSize: { xl: '20px', lg: '15px' } }} >
                            CICB - Centro Internacional de Convenções do Brasil
                        </Typography>
                        <Typography sx={{ fontSize: { xl: '20px', lg: '15px' } }} >
                            Setor de Clubes Esportivos Sul, <br />
                            Trecho 2 Conj.63, lote 50
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold', fontSize: { xl: '20px', lg: '15px' } }}>
                            BRASÍLIA/DF
                        </Typography>
                        <Button variant='text' size='medium' onClick={linkcicb} sx={{ color: '#fff', fontWeight: 'bold', borderRadius: '25px', width: '15rem', mt: '2%' }}>
                            VER NO MAPA <MapOutlinedIcon />
                        </Button>
                    </Grid>
                </Grid>
                
                
            </div>
        </div>

    );
}
